import { post } from '@/utils/request'

export default {
    followingList: query => post('/rrbi/follow/userFollowings/getPage', query),
    follower: followingUserId => post('/rrbi/follow/' + followingUserId),
    undoFollower: followingUserId => post('/rrbi/follow/undo/' + followingUserId),
    followerList: query => post('/rrbi/follow/userFollower/getPage', query),
    collectPageList: query => post('/rrbi/collect/getPage', query),
    getUserInfo: userId => post('/rrbi/userInfo/userInfo/' + userId),
    userPageVistor: userId => post('/rrbi/userInfo/userInfo-vistor/' + userId)
}